import React from 'react';
import { Typography } from '@mui/material';
import { getCaregiverDisplayName } from './utils/timelineCaregiverLabels';

const TimelineEntryAttribution = ({ entry = {} }) => {
  const scenes = Array.isArray(entry.sourceStoryScenes) ? entry.sourceStoryScenes : [];
  const authorName = getCaregiverDisplayName(entry)
    || scenes.map(getCaregiverDisplayName).find(Boolean)
    || '';

  return (
    <Typography sx={{
      fontSize: '0.8rem',
      color: 'text.secondary',
      lineHeight: 1.45,
      overflowWrap: 'anywhere',
    }}>
      {authorName ? `Logged by ${authorName}` : 'Author not recorded'}
    </Typography>
  );
};

export default TimelineEntryAttribution;
